import React from "react";
import FormStation from "../components/FormStation";
import hipladeTemplate from "../../common/template";

function StationForm() {
  return <FormStation />;
}

export default hipladeTemplate(StationForm);
